import Axios from "../../api/Axios";
const BASE_URL = "DocumentAdjustment/";
const BASE_URL_Concurrent = "ConcurrentUserLock/";
export const Endpoint = {
    GetPartyName: "GetPartyName",
    GetCustDetl:"GetCustDetl",
    GetPayableDocument: "GetPayableDocument",
    GetReceivableDocument: "GetReceivableDocument",
    GetDocumentAdjustment: "GetDocumentAdjustment",
    ViewDocumentAdjustment: "ViewDocumentAdjustment",
    SaveDocumentAdjustment: "SaveDocumentAdjustment",
    GenerateOTP: "GenerateOTP",
    ValidateOTP: "ValidateOTP",
    ViewDocumentAdjustmentData: "ViewDocumentAdjustmentData",
    AcquireLock : "AcquireLock",
    ReleaseLock : "ReleaseLock"
};

// /api/DocumentAdjustment/GetPartyName
// /api/DocumentAdjustment/GetPayableDocument
// /api/DocumentAdjustment/GetReceivableDocument
// /api/DocumentAdjustment/SaveDocumentAdjustment
// /api/DocumentAdjustment/GetDocumentAdjustment
// /api/DocumentAdjustment/ViewDocumentAdjustment

export const createAPIDocumentEndpoint = () => {
    return {
        get: (Endpoint) => Axios.get(BASE_URL + Endpoint),
        getConcurrent: (Endpoint) => Axios.get(BASE_URL_Concurrent + Endpoint),
        post: (Endpoint, data) => Axios.post(BASE_URL + Endpoint, data),
        postConcurrent: (Endpoint, data) => Axios.post(BASE_URL_Concurrent + Endpoint, data),
    };
};